"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuidv4 = uuidv4;
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Simple implementation to create a uuid using crypto
 * See: https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid
 * @returns {*}
 */
function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}